module.exports = __webpack_public_path__ + "static/img/theme1.30642505.png";